import "../../css/components/HTML.scss";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Parser from "./HTMLParser";
import Logger from "../utils/Logger";
import Dynamic from "./Dynamic";
import g from "../utils/globals";

const logger = new Logger(__filename);

class HTML extends Component {
  componentDidMount = () => {
    if (this.props.enhancement && !this.props.enhancement.Content) {
      this.loadEnhancement(this.props.enhancement, true);
      const fileName = this.props.dataAttrs["data-content"];
      const contentEnhancement = this.props.enhancement[fileName] || {};
      this.loadEnhancement(contentEnhancement);
    }
  };
  loadEnhancement = (fn, once = false) => {
    if (!fn || !fn.init) return;
    if (!once || !g.enhancementsLoaded.includes(this.props.attrs.id)) {
      try {
        fn.init(this);
        logger.log(`... enhancing content [${this.props.attrs.id}]`);
        if (once) {
          g.enhancementsLoaded.push(this.props.attrs.id);
        }
      } catch (error) {
        logger.error(`Enhancement error: ${this.props.attrs.id}`);
        logger.debug(error);
      }
    }
  };
  render = () => {
    if (this.props.content || this.props.customHTML) {
      const staticVideos =
        this.props.enhancement &&
        (this.props.enhancement.staticVideos ||
          (this.props.dataAttrs &&
            this.props.enhancement[this.props.dataAttrs["data-content"]] &&
            this.props.enhancement[this.props.dataAttrs["data-content"]].staticVideos));
      const noLazy = this.props.enhancement?.noLazy || this.props.enhancement?.[this.props.dataAttrs?.["data-content"]]?.noLazy;
      const playingVideos =
        this.props.enhancement?.playingVideos || this.props.enhancement?.[this.props.dataAttrs?.["data-content"]]?.playingVideos;
      return (
        <div
          ref={el => {
            this.el = el;
          }}
          {...this.props.attrs}
        >
          {Parser(this.props.content ? this.props.content : this.props.customHTML, this.props.root, staticVideos, noLazy, playingVideos)}
          {!g.channels.desktop ? (
            <Fragment>
              <br />
              <br />
            </Fragment>
          ) : null}
        </div>
      );
    }
    return (
      <div
        ref={el => {
          this.el = el;
        }}
        {...this.props.attrs}
      >
        {this.props.contents.map((content, k) => (
          <Dynamic {...content} key={k} />
        ))}
      </div>
    );
  };
}

HTML.propTypes = {
  content: PropTypes.string,
  enhancement: PropTypes.shape({
    init: PropTypes.func,
  }),
  attrs: PropTypes.shape({
    id: PropTypes.string,
  }),
  contents: PropTypes.any,
};

export default HTML;
